import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import HotComicsGrid from './components/HotComicsGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import { useEffect, useState, useRef } from 'react';

export default function Home() {
  const [animationTriggered, setAnimationTriggered] = useState<Record<string, boolean>>({});
  const sectionsRef = useRef<Record<string, HTMLElement | null>>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-section');
            if (id) {
              setAnimationTriggered((prev) => ({ ...prev, [id]: true }));
            }
          }
        });
      },
      { threshold: 0.15 }
    );

    const currentSections = { ...sectionsRef.current };
    Object.values(currentSections).forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />

        <div
          ref={(el) => { sectionsRef.current.features = el; }}
          data-section="features"
          className={`transition-all duration-700 ${
            animationTriggered.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <FeatureGrid />
        </div>

        <div
          ref={(el) => { sectionsRef.current.hot = el; }}
          data-section="hot"
          className={`transition-all duration-700 delay-100 ${
            animationTriggered.hot ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <HotComicsGrid />
        </div>

        <div
          ref={(el) => { sectionsRef.current.reviews = el; }}
          data-section="reviews"
          className={`transition-all duration-700 delay-100 ${
            animationTriggered.reviews ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <Testimonials />
        </div>

        <div
          ref={(el) => { sectionsRef.current.cta = el; }}
          data-section="cta"
          className={`transition-all duration-700 delay-100 ${
            animationTriggered.cta ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <CTASection />
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫漫画网',
            url: 'http://j3zb.com/',
            description: '韩漫漫画网是热门漫画在线阅读平台，实现全网韩漫最快更新，涵盖韩漫大全，内容多样，加载快捷，为您提供极速阅读服务。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://j3zb.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫漫画网',
            url: 'http://j3zb.com/',
            description: '韩漫漫画网是热门漫画在线阅读平台，实现全网韩漫最快更新，涵盖韩漫大全。',
            foundingDate: '2020',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京市',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-6666',
              contactType: 'customer service',
              email: 'hello@j3zb.com',
              areaServed: 'CN',
              availableLanguage: 'Chinese',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            '@id': 'http://j3zb.com/',
            url: 'http://j3zb.com/',
            name: '韩漫漫画网 - 热门漫画在线阅读平台',
            description: '韩漫漫画网是热门漫画在线阅读平台，实现全网韩漫最快更新，涵盖韩漫大全，内容多样，加载快捷，为您提供极速阅读服务。',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫漫画网',
              url: 'http://j3zb.com/',
            },
            about: {
              '@type': 'Organization',
              name: '韩漫漫画网',
            },
          }),
        }}
      />
    </>
  );
}